<button mat-icon-button class="mobile-close-btn" (click)="onItemClick()" aria-label="Close sidebar">
  <mat-icon>close</mat-icon>
</button>

<a routerLink="/modules" class="sidebar-logo-section" (click)="onItemClick()">
  <img src="assets/images/logo.png" alt="RKUMP Logo" class="logo">
  <div class="logo-text">
    <span class="hindi-title">राज्य कृषि उत्पादन मंडी परिषद, उत्तर प्रदेश</span>
    <span class="eng-title">State Agricultural Produce Markets Board Uttar Pradesh</span>
  </div>
</a>

<div class="sidebar-content">
  <!-- Top-level accordion with multi="false" to ensure opening one dropdown automatically closes other open dropdowns -->
  <mat-accordion class="sidebar-accordion" [multi]="false">
    <ng-container *ngFor="let item of filteredMenuItems">

      <!-- Has Children: Render as Expansion Panel -->
      <mat-expansion-panel
        *ngIf="item.children && item.children.length > 0"
        class="sidebar-panel"
        [expanded]="isPanelExpanded(item)"
        (opened)="onPanelOpened(item.id)"
        (closed)="onPanelClosed(item.id)">
        <mat-expansion-panel-header class="sidebar-panel-header" [class.panel-header-active]="isPanelExpanded(item)">
          <mat-panel-title>
            <mat-icon *ngIf="item.icon" class="item-icon">{{ item.icon }}</mat-icon>
            <img *ngIf="item.imgIcon" [src]="item.imgIcon" class="custom-item-icon" alt="">
            <span>{{ item.label | translate }}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="sidebar-submenu">
          <ng-container *ngFor="let child of item.children">

            <!-- Level 2: Has Children (3rd level) -->
            <mat-accordion *ngIf="child.children && child.children.length > 0"
              class="sidebar-accordion nested-accordion" [multi]="false">
              <mat-expansion-panel
                class="sidebar-panel nested-panel"
                [expanded]="nestedExpandedPanelId === child.id"
                (opened)="onNestedPanelOpened(child.id)"
                (closed)="onNestedPanelClosed(child.id)">
                <mat-expansion-panel-header class="sidebar-panel-header" style="padding-left: 2rem;">
                  <mat-panel-title>
                    <mat-icon *ngIf="child.icon" class="item-icon">{{ child.icon }}</mat-icon>
                    <img *ngIf="child.imgIcon" [src]="child.imgIcon" class="custom-item-icon" alt="">
                    <span>{{ child.label | translate }}</span>
                  </mat-panel-title>
                </mat-expansion-panel-header>

                <div class="sidebar-submenu nested-submenu">
                  <a *ngFor="let subchild of child.children" [routerLink]="subchild.route" routerLinkActive="active"
                    class="submenu-item" style="padding-left: 3rem;" (click)="onItemClick()">
                    <span>{{ subchild.label | translate }}</span>
                  </a>
                </div>
              </mat-expansion-panel>
            </mat-accordion>

            <!-- Level 2: No Children -->
            <a *ngIf="!child.children || child.children.length === 0" [routerLink]="child.route"
              [class.active]="isChildActive(child, item.children || [])" class="submenu-item"
              (click)="onItemClick()">
              <mat-icon *ngIf="child.icon" class="item-icon">{{ child.icon }}</mat-icon>
              <img *ngIf="child.imgIcon" [src]="child.imgIcon" class="custom-item-icon" alt="">
              <span>{{ child.label | translate }}</span>
            </a>

          </ng-container>
        </div>
      </mat-expansion-panel>

      <!-- No Children: Render as Simple Link -->
      <a *ngIf="!item.children || item.children.length === 0" [routerLink]="item.route" routerLinkActive="active"
        [routerLinkActiveOptions]="item.exact ? {exact: true} : {exact: false}" class="sidebar-item"
        (click)="onItemClick()">
        <mat-icon *ngIf="item.icon" class="item-icon">{{ item.icon }}</mat-icon>
        <img *ngIf="item.imgIcon" [src]="item.imgIcon" class="custom-item-icon" alt="">
        <span>{{ item.label | translate }}</span>
      </a>

    </ng-container>
  </mat-accordion>
</div>